import { TranslationService } from "@/core/services/TranslationService";

export function siteTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.siteName"),
      key: "siteName",
      sortable: true,
      sortingField: "site_name",
    },
    {
      name: TranslationService.translate("pages.form.siteNumber"),
      key: "siteNumber",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.onTime"),
      key: "onTime",
      sortable: true,
      sortingField: "on_time",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.outsidePeriod"),
      key: "outsidePeriod",
      sortable: true,
      sortingField: "outside_period",
      attrs: {
        class: "vz-dataTable-center",
      },
    },

    {
      name: TranslationService.translate("common.expired"),
      key: "expire",
      sortable: true,
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    //
  ];
}

export function siteTableFilters() {
  return [
    {
      key: "siteFilterId",
      label: TranslationService.translate("pages.site.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}
export function dashboardChartOptions() {
  return {
    colors: ["#4caf50", "#ff9800", "#BF0A30"],
    chart: {
      id: "siteBarChart",
      type: "bar",
      height: 350,
      stacked: true,
      locales: [
        {
          name: "en",
          options: {
            toolbar: {
              exportToSVG: "Export SVG",
              exportToPNG: "Export PNG",
              exportToCSV: "Export CSV",
            },
          },
        },
      ],
      defaultLocale: "en",
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    title: {},
    xaxis: {
      categories: [""],
      labels: {},
    },
    yaxis: {
      title: {
        text: undefined,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    fill: {
      opacity: 1,
      colors: ["#4caf50", "#ff9800", "#BF0A30"],
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      offsetX: 40,
    },
  };
}
